import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "NOT",
  order: 50,
};
